<template>
  <div class="language-switcher" ref="languageSwitcherRef">
    <div class="language-toggle" @click="toggleLanguageOptions">
      <i class="pi pi-globe" style="font-size: 1.2rem"></i>
      <span class="current-lang">{{ currentLanguage === 'en' ? 'English' : 'Español' }}</span>
    </div>
    <div class="language-popup" v-if="showLanguageOptions" @click.stop>
      <div class="language-popup-header">
        {{ $t('common.translatePage') }}
      </div>
      <div class="language-option" :class="{ active: currentLanguage === 'en' }" @click="selectLanguage('en')">
        <span class="flag">🇺🇸</span>
        <span>Translate to English</span>
        <i class="pi pi-check" v-if="currentLanguage === 'en'"></i>
      </div>
      <div class="language-option" :class="{ active: currentLanguage === 'es' }" @click="selectLanguage('es')">
        <span class="flag">🇪🇸</span>
        <span>Traducir al Español</span>
        <i class="pi pi-check" v-if="currentLanguage === 'es'"></i>
      </div>
    </div>
  </div>
  <Toast />
  <router-view></router-view>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterView } from 'vue-router';

const { locale } = useI18n();
const currentLanguage = ref(locale.value);
const showLanguageOptions = ref(false);
const languageSwitcherRef = ref(null);

const selectLanguage = (lang) => {
  currentLanguage.value = lang;
  locale.value = lang;
  localStorage.setItem('userLanguage', lang);
  showLanguageOptions.value = false;
};

const toggleLanguageOptions = (event) => {
  event.stopPropagation();
  showLanguageOptions.value = !showLanguageOptions.value;
};

const handleClickOutside = (event) => {
  // Only close if clicking outside and menu is open
  if (showLanguageOptions.value &&
    languageSwitcherRef.value &&
    !languageSwitcherRef.value.contains(event.target)) {
    showLanguageOptions.value = false;
  }
};

onMounted(() => {
  // Use capture phase to ensure our handler runs first
  document.addEventListener('click', handleClickOutside, true);

});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside, true);
});

// Load saved language preference on mount
if (localStorage.getItem('userLanguage')) {
  currentLanguage.value = localStorage.getItem('userLanguage');
  locale.value = currentLanguage.value;
}
</script>

<style>
/* Global styles */
html,
body {
  margin: 0;
  padding: 0;
  min-height: 80vh;
  background: linear-gradient(135deg,
      #1e3c72 0%,
      #6b4b8c 50%,
      #2a5298 100%);
}
</style>

<style scoped>
/* Component scoped styles */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 100vh;
}

.table-like {
  white-space: nowrap;
  /* Prevent wrapping to new lines */
}

.pair-container {
  display: inline-block;
  /* Display pairs inline */
  margin-right: 20px;
  /* Add spacing between pairs */
}

.pair {
  display: inline-block;
  /* Make pairs inline-block */
  vertical-align: top;
  /* Align pairs to top */
  width: 250px;
  /* Set initial width for all pairs */
  overflow: hidden;
  /* Hide overflow for long keys */
}

.key {
  font-weight: bold;
  /* Optionally, make keys bold */
  display: inline-block;
  /* Ensure keys are displayed inline */
}

.value {
  display: inline-block;
  /* Ensure values are displayed inline */
  margin-left: 5px;
  /* Add spacing between key and value */
  vertical-align: top;
  /* Align values to top */
}

/* .custom-upload-button {
  /* background-color: #4CAF50;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 4px; */
/* } */


/* Hide default file input */
input[type="file"] {
  display: none;
}

.file-info {
  margin-top: 10px;
}

.file-name {
  margin-right: 10px;
}

.file-progress {
  font-style: italic;
}

select {
  padding: 8px 12px;
  /* Adjust the padding of the select button */
  margin-left: 20px;
  border: 1px solid #ccc;
  /* Add a border to the select button */
  border-radius: 4px;
  /* Add border radius to the select button */
  background-color: #fff;
  /* Set the background color of the select button */
  font-size: 14px;
  /* Adjust the font size of the select button */
  color: #333;
  /* Set the text color of the select button */
  cursor: pointer;
  /* Change cursor to pointer when hovering over the select button */
}

form {
  max-width: 400px;
  text-align: left;
}

.for {
  margin-bottom: 15px;
  text-align: left;
}

.lab {
  display: block;
  margin-bottom: 5px;
}

.in {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

#app1 {
  text-align: left;
}

.language-switcher {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.language-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  padding: 10px 15px;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  border: 2px solid #4CAF50;
}

.language-toggle:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  background: #4CAF50;
  color: white;
}

.current-lang {
  font-weight: 600;
  font-size: 0.9rem;
}

.language-popup {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 240px;
  overflow: hidden;
}

.language-popup-header {
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-weight: 500;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-option:hover {
  background: #f8f9fa;
}

.language-option.active {
  background: #e8f5e9;
  color: #4CAF50;
}

.language-option i {
  margin-left: auto;
}

.flag {
  font-size: 1.2rem;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.language-options {
  animation: slideIn 0.3s ease-out;
}
</style>
